import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-right-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-44753c98")

_pushScopeId("data-v-44753c98")
const _hoisted_1 = { class: "w-1/12" }
const _hoisted_2 = { class: "w-10/12 text-16px font-semibold" }
const _hoisted_3 = { class: "flex items-center relative gap-1" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-12px w-56 flex flex-col text-black-lp-300 space-y-2" }
const _hoisted_6 = { class: "text-gray-lp-800" }
const _hoisted_7 = { class: "grid grid-cols-5 gap-y-2" }
const _hoisted_8 = { class: "col-span-2" }
const _hoisted_9 = { class: "text-14px font-semibold" }
const _hoisted_10 = { class: "text-gray-lp-800 ellipsis-2" }
const _hoisted_11 = { class: "flex justify-center" }
const _hoisted_12 = { class: "col-span-2" }
const _hoisted_13 = { class: "text-14px font-semibold" }
const _hoisted_14 = { class: "text-gray-lp-800 ellipsis-2" }
const _hoisted_15 = { class: "col-span-4" }
const _hoisted_16 = { class: "text-14px font-semibold" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-800" }, "Durasi Penerbangan", -1)
const _hoisted_19 = { class: "col-span-4" }
const _hoisted_20 = { class: "text-14px font-semibold" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-800" }, "No. Penerbangan", -1)
const _hoisted_22 = {
  key: 0,
  class: "text-14px font-normal justify-between w-full flex items-center pt-4 gap-x-6"
}
const _hoisted_23 = { class: "w-5/12 ellipsis-2" }
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  class: "w-1/12",
  src: _imports_0,
  alt: "right"
}, null, -1)
const _hoisted_25 = { class: "w-5/12 ellipsis-2" }
const _hoisted_26 = {
  key: 1,
  class: "text-14px w-full flex items-center pt-4 gap-x-3"
}
const _hoisted_27 = { class: "ellipsis-2" }
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  class: "w-5",
  src: _imports_0,
  alt: "right"
}, null, -1)
const _hoisted_29 = { class: "ellipsis-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createBlock("div", {
    class: ["border rounded-md p-4 text-white space-y-3", _ctx.styleCard],
    style: {"width":"30rem"}
  }, [
    _createVNode("div", {
      class: `flex gap-x-6 ${_ctx.isCenterVertical ? 'items-center' : ''}`
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          class: [_ctx.styleTextNumber, "numberWithCircle text-14px font-medium"]
        }, _toDisplayString(_ctx.index + 1), 3)
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", null, "Jadwal Pesawat " + _toDisplayString(_ctx.index + 1), 1),
          (_ctx.data.FlightNo)
            ? (_openBlock(), _createBlock("span", _hoisted_4, "(" + _toDisplayString(_ctx.data.FlightNo) + ")", 1))
            : _createCommentVNode("", true),
          _createVNode(_component_OverlayPanel, {
            ref: "opTooltip",
            appendTo: "body"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, _toDisplayString(_ctx.moment(_ctx.tooltipFLightData.DepartureDateTime).format(
                  "DD MMMM YYYY"
                )), 1),
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("p", _hoisted_9, _toDisplayString(_ctx.moment(_ctx.tooltipFLightData.DepartureDateTime).format(
                        "HH:mm"
                      )), 1),
                    _createVNode("p", _hoisted_10, _toDisplayString(_ctx.data.origin), 1)
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("img", {
                      src: require(`@/app/ui/assets/svg/arrow-right-gray.svg`),
                      class: "w-5",
                      alt: "right"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("p", _hoisted_13, _toDisplayString(_ctx.moment(_ctx.tooltipFLightData.ArrivalDateTime).format("HH:mm")), 1),
                    _createVNode("p", _hoisted_14, _toDisplayString(_ctx.data.destination), 1)
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode("p", _hoisted_16, [
                      (_ctx.differenceDate.hours)
                        ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(_ctx.differenceDate.hours) + " Jam ", 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.differenceDate.minutes) + " Menit ", 1)
                    ]),
                    _hoisted_18
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("p", _hoisted_20, _toDisplayString(_ctx.tooltipFLightData.FlightNo), 1),
                    _hoisted_21
                  ])
                ])
              ])
            ]),
            _: 1
          }, 512),
          (_ctx.progressData === 'done')
            ? (_openBlock(), _createBlock("img", {
                key: 1,
                src: 
              require(`@/app/ui/assets/svg/${
                _ctx.isTooltip ? 'info-red' : 'info-white'
              }.svg`)
            ,
                class: "ml-2 w-5 cursor-pointer",
                onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltipHeader($event))),
                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltipHeader($event))),
                alt: "info"
              }, null, 40, ["src"]))
            : _createCommentVNode("", true),
          (_ctx.progressData === 'done')
            ? (_openBlock(), _createBlock(_component_lp_button, {
                key: 2,
                class: "absolute top-0 right-0",
                compact: "",
                rounded: "",
                "custom-class": "px-2",
                title: "Ubah",
                color: "white",
                "text-color": "green-lp-100",
                onClick: _ctx.changeFlightSchedule,
                disabled: _ctx.isLoading
              }, null, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.data.origin && _ctx.data.destination)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.data.origin), 1),
              _hoisted_24,
              _createVNode("div", _hoisted_25, _toDisplayString(_ctx.data.destination), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.DepartureDateTime && _ctx.data.ArrivalDateTime)
          ? (_openBlock(), _createBlock("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, _toDisplayString(_ctx.moment(_ctx.data.DepartureDateTime).format("HH:mm")), 1),
              _hoisted_28,
              _createVNode("div", _hoisted_29, _toDisplayString(_ctx.moment(_ctx.data.ArrivalDateTime).format("HH:mm")), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 2))
})